import React, { useState } from "react";

export default function FAQ() {
  const [openKey, setOpenKey] = useState(null);

  const toggleFAQ = (key) => {
    setOpenKey(openKey === key ? null : key);
  };

  return (
    <div className="main-container">
      <h2 className="section-title">Frequently Asked Questions (FAQ)</h2>

      <p>
        This section provides answers to commonly asked questions related to the
        IYC mobile application, membership, profile management, payments, and
        other features.
      </p>

      {faqSections.map((section, sectionIndex) => (
        <div key={section.title} style={{ marginTop: 32 }}>
          <h3 style={{ color: "#032A66", marginBottom: 16 }}>
            {section.title}
          </h3>

          {section.items.map((faq, itemIndex) => {
            const key = `${sectionIndex}-${itemIndex}`;
            const isOpen = openKey === key;

            return (
              <div
                key={key}
                style={{
                  marginBottom: 14,
                  borderRadius: 10,
                  background: "#f8fbff",
                  boxShadow: "0 4px 14px rgba(3,42,102,0.06)",
                  overflow: "hidden",
                }}
              >
                {/* Question */}
                <button
                  onClick={() => toggleFAQ(key)}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    padding: "16px 18px",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontFamily: "var(--font-family-app)",
                    fontSize: 16,
                    fontWeight: 700,
                    color: "var(--primary)",
                  }}
                >
                  <span>{faq.q}</span>
                  <span
                    style={{
                      fontSize: 22,
                      lineHeight: 1,
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                      transition: "transform 0.2s ease",
                    }}
                  >
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && (
                  <div
                    style={{
                      padding: "0 18px 18px",
                      color: "#3b3b3b",
                      lineHeight: 1.7,
                      fontSize: 15,
                    }}
                  >
                    {faq.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

/* =========================
   FAQ DATA
========================= */

const faqSections = [
  {
    title: "Login & App Access",
    items: [
      {
        q: "How do I log in to the IYC App?",
        a: "Open the app, enter your registered mobile number, and verify using the OTP received via SMS.",
      },
      {
        q: "Where can I find the logout button?",
        a: "The logout button is located at the top-right corner of the screen and is represented by an outward arrow icon.",
      },
      {
        q: "What should I do if I am not receiving the OTP?",
        a: "Please check your internet connection and ensure it is stable. OTP delivery may fail due to poor connectivity.",
      },
      {
        q: "What should I do if the app screen is blank or not loading?",
        a: "Check your internet connection. If the issue continues, close the app completely and reopen it.",
      },
      {
        q: "What should I do if missed call or OTP verification is not working?",
        a: "This issue is usually related to internet connectivity. Please ensure you have a stable internet connection.",
      },
    ],
  },

  {
    title: "Membership Section",
    items: [
      {
        q: "How do I access the membership reports?",
        a: "Navigate to the Membership tab and tap on Membership Reports to view relevant reports.",
      },
      {
        q: "How do I review specific batches under scrutiny?",
        a: "Go to Membership > Scrutiny and use the search bar to find and review specific batches.",
      },
      {
        q: "How can I submit a complaint?",
        a: "Tap on Membership > Complaint, select your state (if eligible), and submit your complaint.",
      },
      {
        q: "What is RO Access and how can I use it?",
        a: "RO Access allows you to manage Nomination and Membership. Report this option under the Membership tab.",
      },
    ],
  },

  {
    title: "Profile Section",
    items: [
      {
        q: "How can I track my activities?",
        a: "Go to Profile > My Activities to track tasks under New, Completed, and Expired categories.",
      },
      {
        q: "How can I track my performance in the app?",
        a: "Navigate to Profile > My Points to view total earned points and filter by month or year.",
      },
      {
        q: "How do I check my rewards?",
        a: "Go to Profile > My Rewards to view and redeem earned rewards.",
      },
      {
        q: "How can I manage my calendar events?",
        a: "Tap on Profile > My Calendar to view scheduled events and create new programs.",
      },
      {
        q: "How do I update my personal details?",
        a: "Go to Profile > My Profile and use the edit option to update your name and address. State and district cannot be edited.",
      },
    ],
  },

  {
    title: "Payment Issues & Help Center",
    items: [
      {
        q: "How can I make a payment in the IYC App?",
        a: "You can make payments using UPI, debit/credit cards, or net banking.",
      },
      {
        q: "My payment failed. What should I do?",
        a: "Check internet connectivity, ensure sufficient balance, try another payment method, or retry after a few minutes.",
      },
      {
        q: "How can I check my payment status?",
        a: "Go to Profile > Payment History to check transaction status.",
      },
      {
        q: "How long does it take to receive a refund?",
        a: "Refunds usually take 5–7 business days depending on bank processing time.",
      },
    ],
  },
];
